// extracted by mini-css-extract-plugin
export default {"tabNavigator":"TabNavigator_tabNavigator__4CBjS","thumb":"TabNavigator_thumb__4h+Pg","tabButton":"TabNavigator_tabButton__vEFLM","active":"TabNavigator_active__e3bdA"};